import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import { UserService } from 'src/app/shared-lib/domains/user';
import { cleanedWallet } from '../shared-lib/domains/wallet/wallet.helpers';
import { WalletService } from '../shared-lib/domains/wallet/wallet.service';

@Injectable({ providedIn: 'root' })
export class WalletFlows {
  private initialized = false;

  private readonly walletState$ = this.userService.user$.pipe(
    switchMap(user => user?.id ? this.walletService.getWalletByUserId$(user.id) : of(cleanedWallet())),
    shareReplay({ bufferSize: 1, refCount: true })
  );

  constructor(
    private walletService: WalletService,
    private userService: UserService
  ) { }

  init(): void {
    if (this.initialized) {
      return;
    }

    this.initialized = true;

    // Se suscribe a los cambios del estado de la wallet y actualiza el servicio de wallet
    this.walletState$.subscribe(wallet => {
      const shouldNotify = !!wallet?.userId;
      this.walletService.updateCurrentWallet(wallet, shouldNotify);
    });
  }
}
